import React from 'react';
import MultiSelectSearch, { SelectOption } from './MultiSelectSearch';
import styles from './AdvancedFilters.module.css';

export interface GlobalFilters {
  unidadAcademica: string[];
  evaluationStatus: string[];
  evaluador: string[];
  researcherType: string[];
  evaluatorStatus: string[];
}

export const EMPTY_FILTERS: GlobalFilters = {
  unidadAcademica: [],
  evaluationStatus: [],
  evaluador: [],
  researcherType: [],
  evaluatorStatus: [],
};

export interface FilterOptions {
  unidadAcademica: string[];
  evaluators: SelectOption[];
}

interface AdvancedFiltersProps {
  filters: GlobalFilters;
  onChange: (filters: GlobalFilters) => void;
  options: FilterOptions;
}

const EVALUATION_STATUS_OPTIONS: SelectOption[] = [
  { value: 'Declaración pendiente', label: 'Declaración pendiente' },
  { value: 'Pendiente', label: 'Pendiente' },
  { value: 'Completada', label: 'Completada' },
  { value: 'Conflicto declarado', label: 'Conflicto declarado' },
];

const RESEARCHER_TYPE_OPTIONS: SelectOption[] = [
  { value: 'consolidated', label: 'Consolidado' },
  { value: 'emerging', label: 'Emergente' },
];

const EVALUATOR_STATUS_OPTIONS: SelectOption[] = [
  { value: 'assigned', label: 'Con evaluador asignado' },
  { value: 'unassigned', label: 'Sin evaluador asignado' },
];

const AdvancedFilters: React.FC<AdvancedFiltersProps> = ({
  filters,
  onChange,
  options,
}) => {
  const set =
    (key: keyof GlobalFilters) => (value: string[] | string) => {
      onChange({ ...filters, [key]: value });
    };

  const activeCount = [
    filters.unidadAcademica.length > 0,
    filters.evaluationStatus.length > 0,
    filters.evaluador.length > 0,
    filters.researcherType.length > 0,
    filters.evaluatorStatus.length > 0,
  ].filter(Boolean).length;

  const clearAll = () => onChange({ ...EMPTY_FILTERS });

  const uaOptions: SelectOption[] = options.unidadAcademica.map((v) => ({
    value: v,
    label: v,
  }));
  return (
    <div className={styles.container}>
      <div className={styles.panel}>
        <div className={styles.row}>
          <MultiSelectSearch
            label="Unidad Académica"
            options={uaOptions}
            selected={filters.unidadAcademica}
            onChange={set('unidadAcademica') as (v: string[]) => void}
            placeholder="Buscar unidad..."
          />
          <MultiSelectSearch
            label="Estado evaluación"
            options={EVALUATION_STATUS_OPTIONS}
            selected={filters.evaluationStatus}
            onChange={set('evaluationStatus') as (v: string[]) => void}
          />
          <MultiSelectSearch
            label="Evaluador"
            options={options.evaluators}
            selected={filters.evaluador}
            onChange={set('evaluador') as (v: string[]) => void}
            placeholder="Buscar evaluador..."
          />
          <MultiSelectSearch
            label="Tipo Investigador"
            options={RESEARCHER_TYPE_OPTIONS}
            selected={filters.researcherType}
            onChange={set('researcherType') as (v: string[]) => void}
          />
          <MultiSelectSearch
            label="Estado Evaluador"
            options={EVALUATOR_STATUS_OPTIONS}
            selected={filters.evaluatorStatus}
            onChange={set('evaluatorStatus') as (v: string[]) => void}
          />
        </div>

        {activeCount > 0 && (
          <button
            type="button"
            className={styles.clearAll}
            onClick={clearAll}
          >
            Limpiar todos los filtros
          </button>
        )}
      </div>
    </div>
  );
};

export default AdvancedFilters;
